<template>
	<div class="guideContainer trackCanv" :style="{ width: `${width}px` }">
		<div
			v-for="({ startTime, endTime }, index) in guides"
			class="guide"
			:key="`guide-${index}`"
			:style="{
				left: `${100 * convertSecondsToProportion(startTime, offset, zoom)}%`,
				width: `${(100 * (endTime - startTime) * basePxPerSec * zoom) / width}%`,
			}"
		/>
	</div>
</template>
<script>
export default {
	props: {
		guides: {
			type: Array,
            default: () => []
		},
        offset: {
            type: Number
        },
        zoom: {
            type: Number
        },
        width: {
            type: Number
        },
        basePxPerSec: {
            type: Number
        }
	},
    methods: {
        convertSecondsToProportion(t, offset, zoom) {
			const pxFromStart = t * (this.basePxPerSec * zoom);
			const pxCursor = offset * this.width;
			return ((pxFromStart - pxCursor)/this.width) + 0.5;
		},
    }
};
</script>
<style lang="scss" scoped>
.guideContainer {
    position: absolute;
}
.guide {
	height: 20px;
	position: absolute;
	background: #ef1a1c;
	opacity: 0.3;
	top: -20px;
}
</style>
